package feature.product.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Product(
    @SerialName("_id") var Id: String = "",
    @SerialName("ProductID") var ProductID: Int? = null,
    @SerialName("UserID") var UserID: String? = null,
    @SerialName("BusinessID") var BusinessID: String? = null,
    @SerialName("CategoryID") var CategoryID: String? = null,
    @SerialName("SubCategoryID") var SubCategoryID: String? = null,
    @SerialName("IsDeleted") var IsDeleted: Boolean? = null,
    @SerialName("Name") var Name: String? = null,
    @SerialName("Description") var Description: String = "",
    @SerialName("ManageInventory") var ManageInventory: Boolean? = null,
    @SerialName("ProductPrice") var ProductPrice: ProductPrice = ProductPrice(),
    @SerialName("CreatedAt") var CreatedAt: String? = null,
    @SerialName("UpdatedAt") var UpdatedAt: String? = null,
    @SerialName("__v") var _v: Int? = null
)